import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateDeclaracionJuradaViolenciaGenero = () => {
  const [loadingCreateDeclaracionJuradaViolenciaGenero, setLoadingCreateSolicitudPagoDirecto] = useState(false);
  const [successCreateDeclaracionJuradaViolenciaGenero, setSuccessCreateSolicitudPagoDirecto] = useState(false);
  const [errorCreateDeclaracionJuradaViolenciaGenero, setErrorCreateSolicitudPagoDirecto] = useState(null);
  const [dataCreateDeclaracionJuradaViolenciaGenero, setDataSolicitudPagoDirecto] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createDeclaracionJuradaViolenciaGenero = async (userId:string , data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudPagoDirecto(true);
    setSuccessCreateSolicitudPagoDirecto(false);
    setErrorCreateSolicitudPagoDirecto(null);

    apiRecord.newSolicitudDeclaracionJuradaFuerzaMayor(userId, data).then((res: any) => {
      setLoadingCreateSolicitudPagoDirecto(false);
      setSuccessCreateSolicitudPagoDirecto(true);
      setDataSolicitudPagoDirecto(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudPagoDirecto(false);
      setErrorCreateSolicitudPagoDirecto(err.response.data)
    })
  }




  return {
    createDeclaracionJuradaViolenciaGenero,
    loadingCreateDeclaracionJuradaViolenciaGenero,
    successCreateDeclaracionJuradaViolenciaGenero,
    errorCreateDeclaracionJuradaViolenciaGenero,
    dataCreateDeclaracionJuradaViolenciaGenero
  }

}

export default useCreateDeclaracionJuradaViolenciaGenero;
